import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Progress, Divider } from "antd";
import { useSelector } from "react-redux";
// import useFetch from "../../Controllers/useFetch";
import { gql, useSubscription, useQuery, useLazyQuery } from "@apollo/client";
// import ReactSpeedometer from "react-d3-speedometer";
// import Console from "../../Controllers/console";
import SolarEnergyIcon from "../../Assets/external_icons/color/solar-energy.png";
import LightBulbIcon from "../../Assets/external_icons/color/light-bulb.png";
import BatteryStateIcon from "../../Assets/external_icons/color/power.png";
import BatteryState1Icon from "../../Assets/external_icons/color/power1.png";
import BatteryState2Icon from "../../Assets/external_icons/color/power2.png";
import BatteryState3Icon from "../../Assets/external_icons/color/power3.png";
import BatteryState4Icon from "../../Assets/external_icons/color/power4.png";
import { error } from "../../Controllers/toast";
import Loader from "../../Loader";

const BATTERY_INFO = gql`
  query ($plant_id: Int!, $date_time: Date, $offset_date: Int) {
    GetBatteryInfo(
      plant_id: $plant_id
      date_time: $date_time
      offset_date: $offset_date
    ) {
      BatteryCharge
      BatteryPower
    }
  }
`;

const TOTAL_PLANT_PRODUCTION = gql`
  query ($plant_id: Int!, $date_time: Date, $offset_date: Int, $type: String) {
    TotalPlantProduction(
      plant_id: $plant_id
      date_time: $date_time
      offset_date: $offset_date
      type: $type
    ) {
      TotalBatteriesPower
      TotalMastersPower
      TotalPanelsPower
      TotalSOH
    }
  }
`;

const date_time = new Date();

const PlantStatus = ({
  plant_id,
  fact_power_name,
  fact_power_unit,
  title,
  type,
  setBatteryPower,
}) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [totalMastersPower, setTotalMastersPower] = useState(0);
  const [totalPanelsPower, setTotalPanelsPower] = useState(0);
  const [BatteryCharge, setBatteryCharge] = useState(0);

  // console.log( plant_id , "is plant id")
  const [getBattryInfo, { loading: loadingBattery }] = useLazyQuery(BATTERY_INFO, {
    onError: (err) => {
      console.log(err);
    },
    onCompleted: (res) => {
      // console.log(res);
      if (res.GetBatteryInfo && res.GetBatteryInfo.BatteryCharge && res.GetBatteryInfo.BatteryPower) {

        setBatteryCharge(res.GetBatteryInfo.BatteryCharge);
        // setBatteryPower(res.GetBatteryInfo.BatteryPower);
      }
    },
  });

  const { loading } = useQuery(TOTAL_PLANT_PRODUCTION, {
    variables: { plant_id: parseInt(plant_id), date_time: date_time },
    onCompleted: ({ TotalPlantProduction }) => {
      // console.log(
      //   TotalPlantProduction.TotalMastersPower,
      //   "is TotalPlantProduction"
      // );
      const {
        TotalBatteriesPower,
        TotalMastersPower,
        TotalPanelsPower,
        TotalSOH,
      } = TotalPlantProduction;

      console.log(TotalMastersPower)
      setTotalMastersPower(parseInt(TotalMastersPower));
      setTotalPanelsPower(parseInt(TotalPanelsPower) / 100000);
    },
    onError: (err) => {
      error("مشکلی در دریافت اطلاعات لحظه ای نیروگاه رخ داده است!");
    },
    pollInterval: 20000,
  });
  // console.log(fact_power_name);

  useEffect(() => {
    // if (type === "BatteryCharge") {
    // setInterval(
    //   () =>
    getBattryInfo({
      variables: {
        plant_id: parseInt(plant_id),
        date_time: new Date(),
        offset_date: new Date().getTimezoneOffset(),
      },
      pollInterval: 10000,
    });
    //   10000
    // );
    // }
  }, []);

  const baseUnitCreator = (power_name, power_unit) => {
    switch (power_unit) {
      case "kW":
        return power_name * 1000;
      case " MW":
        return power_name * 1000000;
      default:
        return power_name;
    }
  };

  const BatteryState = (percent) => {
    if (percent <= 25) {
      return BatteryState1Icon;
    } else if (percent > 25 && percent <= 50) {
      return BatteryState2Icon;
    } else if (percent > 50 && percent <= 75) {
      return BatteryState3Icon;
    } else if (percent > 75) {
      return BatteryState4Icon;
    }
  };

  const correctBatteryChargeNumber = (charge) => {
    if (charge > 100) {
      return 100
    } else {
      return charge
    }
  }

  return (
    <Card className="text-center  border-radius-15 h-100 " >
      <CardBody>
        {loadingBattery === true || loading === true && totalMastersPower !== 0 ? (
          <div className="text-center"><Loader /></div>
        ) : (
          <div className="text-center ltr h-100 " style={{ margin: "auto" }}>
            <Row className="text-center h-100 " style={{ margin: "auto" }}>
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <img src={SolarEnergyIcon} width={70}></img>
                <h6 className="text-center mt-1">{lang_choiced.pages.dashboard.plantStatus.totalPanelsProduction}</h6>
                <p
                  className=""
                  style={{
                    direction: "ltr !important",
                    fontSize: "22px",
                    fontWeight: "700",
                  }}
                >
                  {totalPanelsPower > 1000
                    ? (totalPanelsPower / 1000).toFixed(2)
                    : totalPanelsPower > 0
                      ? totalPanelsPower.toFixed(0)
                      : 0}{" "}
                  {totalPanelsPower > 1000 ? "kW" : "W"}
                </p>
              </Col>
              {/* <Divider type="horizontal"  orientation="center" /> */}
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <img
                  src={BatteryState(BatteryCharge / 100)}
                  width={70}
                // style={{ margin: "10px 0" }}
                />
                <h6 className="text-center mt-1">{lang_choiced.pages.dashboard.plantStatus.totalBatteriesCharge}</h6>
                <p
                  className=""
                  style={{
                    direction: "ltr !important",
                    fontSize: "22px",
                    fontWeight: "700",
                  }}
                >
                  {correctBatteryChargeNumber(BatteryCharge / 100).toFixed(0)}%
                </p>
              </Col>
              {/* <Divider type="horizontal"  orientation="center" /> */}
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <img src={LightBulbIcon} width={70} />
                <h6 className="text-center mt-1">{lang_choiced.pages.dashboard.plantStatus.totalPowersConsumption}</h6>
                <p
                  className=""
                  style={{
                    direction: "ltr !important",
                    fontSize: "22px",
                    fontWeight: "700",
                  }}
                >
                  {Math.floor(totalMastersPower / 10000) > 1000 ? `${((totalMastersPower / 10000) / 1000).toFixed(2)} kW` : `${(totalMastersPower / 10000).toFixed(0)} W`}
                </p>
              </Col>
            </Row>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default PlantStatus;
